    import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";

import API_URL from "../../config";

const EditSubscriptionPlan = () => {

    const { id } = useParams();

    const navigate = useNavigate();

    const [loading, setLoading] = useState(true);

    const [formData, setFormData] = useState({

        plan_name: "",

        price: "",

        job_limit: "",

        validity_days: "",

        featured_jobs: "",

        resume_access: false,

        candidate_unlock_limit: "",

        priority_support: false,

        company_branding: false

    });

    useEffect(() => {

        fetchPlan();

    }, []);

    const fetchPlan = async () => {

        try {

            const response = await axios.get(
                `${API_URL}/admin/subscription-plans/${id}`
            );

            setFormData(response.data.data);

        } catch (error) {

            console.error(error);

        } finally {

            setLoading(false);

        }

    };

    const handleChange = (e) => {

        const {

            name,

            value,

            type,

            checked

        } = e.target;

        setFormData({

            ...formData,

            [name]: type === "checkbox" ? checked : value

        });

    };

    const handleSubmit = async (e) => {

        e.preventDefault();

        try {

            await axios.put(

                `${API_URL}/admin/subscription-plans/${id}`,

                formData

            );

            alert("Subscription Plan Updated Successfully.");

            navigate("/admin/subscription-plans");

        } catch (error) {

            console.error(error);

            alert("Update Failed");

        }

    };

    if (loading) {

        return <h3 className="text-center mt-5">Loading...</h3>;

    }

    return (

        <div className="max-w-5xl mx-auto bg-white shadow-lg rounded-2xl p-8 mt-8">

            <h2 className="text-3xl font-bold mb-8">

                Edit Subscription Plan

            </h2>

            <form onSubmit={handleSubmit}>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

                    <div>

                        <label className="font-semibold">

                            Plan Name

                        </label>

                        <input
                            type="text"
                            name="plan_name"
                            value={formData.plan_name}
                            onChange={handleChange}
                            className="w-full border rounded-lg p-3 mt-2"
                            required
                        />

                    </div>

                    <div>

                        <label className="font-semibold">

                            Price

                        </label>

                        <input
                            type="number"
                            name="price"
                            value={formData.price}
                            onChange={handleChange}
                            className="w-full border rounded-lg p-3 mt-2"
                            required
                        />

                    </div>

                    <div>

                        <label className="font-semibold">

                            Job Limit

                        </label>

                        <input
                            type="number"
                            name="job_limit"
                            value={formData.job_limit}
                            onChange={handleChange}
                            className="w-full border rounded-lg p-3 mt-2"
                        />

                    </div>

                    <div>

                        <label className="font-semibold">

                            Validity Days

                        </label>

                        <input
                            type="number"
                            name="validity_days"
                            value={formData.validity_days}
                            onChange={handleChange}
                            className="w-full border rounded-lg p-3 mt-2"
                        />

                    </div>

                    <div>

                        <label className="font-semibold">

                            Featured Jobs

                        </label>

                        <input
                            type="number"
                            name="featured_jobs"
                            value={formData.featured_jobs}
                            onChange={handleChange}
                            className="w-full border rounded-lg p-3 mt-2"
                        />

                    </div>

                    <div>

                        <label className="font-semibold">

                            Candidate Unlock Limit

                        </label>

                        <input
                            type="number"
                            name="candidate_unlock_limit"
                            value={formData.candidate_unlock_limit}
                            onChange={handleChange}
                            className="w-full border rounded-lg p-3 mt-2"
                        />

                    </div>

                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-8">

                    <label className="flex items-center gap-3">

                        <input
                            type="checkbox"
                            name="resume_access"
                            checked={Boolean(formData.resume_access)}
                            onChange={handleChange}
                        />

                        Resume Access

                    </label>

                    <label className="flex items-center gap-3">

                        <input
                            type="checkbox"
                            name="priority_support"
                            checked={Boolean(formData.priority_support)}
                            onChange={handleChange}
                        />

                        Priority Support

                    </label>

                    <label className="flex items-center gap-3">

                        <input
                            type="checkbox"
                            name="company_branding"
                            checked={Boolean(formData.company_branding)}
                            onChange={handleChange}
                        />

                        Company Branding

                    </label>

                </div>

                <div className="flex justify-end gap-4 mt-10">

                    <button
                        type="button"
                        onClick={() => navigate("/admin/subscription-plans")}
                        className="px-6 py-3 bg-gray-500 text-white rounded-lg"
                    >
                        Cancel
                    </button>

                    <button
                        type="submit"
                        className="px-6 py-3 bg-blue-600 text-white rounded-lg"
                    >
                        Update Plan
                    </button>

                </div>

            </form>

        </div>

    );

};

export default EditSubscriptionPlan;